import { render, staticRenderFns } from "./meals-modal.vue?vue&type=template&id=bf46ac84&"
import script from "./meals-modal.vue?vue&type=script&lang=js&"
export * from "./meals-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports